let fileServer = null
export default {
    name: 'FileUtil',
    install(fileServerUrl) {
        fileServer = fileServerUrl
    },
    getFileViewUrl(file) {
        // console.log('file',file)
      if (file && file.indexOf('/static') === 0) {
        let server = fileServer
        server = this.subStringEnd(server, '/api/')
        server = this.subStringEnd(server, '/api')
        return server + file
      }
      return file && file.replace(/{host}/g, fileServer)
    },
    // 若末尾匹配,去掉末尾
    subStringEnd(s, end) {
      let rs = s
      if (s.lastIndexOf(end) === s.length - end.length) {
        rs = s.substring(0, s.length - end.length)
      }
      return rs
    },
    getFileViewContent(richTextContent) {
        if (!richTextContent) {
            return richTextContent;
        }

        // 匹配 src="file，但排除包含文件流的部分
        const regexPattern = /src="file(?![^<]*base64)/g;
        let replace = richTextContent.replace(regexPattern, 'src="' + fileServer + 'file');
        const regexPattern2 = /poster="file(?![^<]*base64)/g;
        replace = replace.replace(regexPattern2, 'src="' + fileServer + 'file');
        return replace;
    },
    appendContent(type, content) {
        // content.log(`appendContent ${type}` , content)
        const element = document.createElement(type);
        if (type === 'script') {
            element.textContent = content;
        } else {
            element.innerHTML = content;
        }
        document.body.appendChild(element);
    },
    getAndAppendToBody(type, content) {
        if (type && content) {
            const scriptRegex = new RegExp(`<${type}\\b[^>]*>([\\s\\S]*?)<\\/${type}>`, 'gm');
            const matches = content.match(scriptRegex);

            // 输出匹配到的 JavaScript 代码
            if (matches) {
                matches.forEach((subContent, index) => {
                    console.log(`getAndAppendToBody <${type}> ${index + 1}:`);
                    this.appendContent(type, subContent.replace(new RegExp(`<${type}\\b[^>]*>|<\\/${type}>`, 'g'), ''))
                });
            } else {
                console.log(`No <${type}> tags found.`);
            }
        }
    },
    downloadFile(fullPath, otherFileName) {
        // Create a link element
        const link = document.createElement('a');

        // Set the href attribute to the file URL
        link.href = fullPath;

        // Set the download attribute with the desired file name
        link.download = otherFileName || this.getFileNameFromPath(fullPath);

        // Append the link to the document
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Remove the link from the document
        document.body.removeChild(link);
    },

    // Helper function to get file name from path
    getFileNameFromPath(path) {
        if (path) {
            const lastSlashIndex = path.lastIndexOf('/');
            return path.substring(lastSlashIndex + 1);
        }
    },
}
